import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get';

interface AppInputTextArea {
    label:string;
    path: string;
    name: string;
    placeholder: string;
    value?: any;
    onChange: any;
    errors: any;
    required?: boolean;
    tip?: string;
    rows?:number;
}


export const AppInputTextArea: FunctionalComponent<AppInputTextArea> = ({ label, path, errors, name, placeholder, value, onChange, rows = 5, required, tip }) => {

    return (
        <div class="uk-margin">
            <label class="uk-form-label" uk-tooltip={tip}>{label} <span class="uk-text-danger">{required && '*'}</span> <span class="uk-text-danger">{get(errors, [path, 'message'])}</span></label>
            <div class="uk-form-controls">
                <textarea class={`uk-textarea ${get(errors, [path, 'message']) ? 'uk-form-danger' : ''}`} rows={rows} placeholder={placeholder} name={name} value={value} onChange={onChange} style={{ 'resize': 'none' }} />
            </div>
        </div>
    )
};


